import { BaseClass } from 'digicon-events-base';

export class Tables extends BaseClass {
    constructor(properties) {
        super();
        this.modules = properties.modules;
    }

    createTables(data) {
        data.forEach(element => {
            var table = "<div class='overflow-y-auto'><table class='table table-bordered'>";
            element.data.forEach(function callback(element2, index) {
                if (index >= element.data.length - element.highlight) {
                    table += "<tr class='highlight'>";
                }
                else {
                    table += "<tr>";
                }
                element2.forEach(element3 => {
                    if (element3 != "" && !isNaN(parseFloat(element3)) && !element3.includes("%")) {
                        let number = element3.replace(",", ".");
                        const commas = number.toString().split(".")[1]?.length || 0;
                        if (commas > 4) {
                            table += `<td>${parseFloat(number).toFixed(4).toString().replace(".", ",")}</td>`;
                        } else {
                            table += `<td>${number.replace(".", ",")}</td>`;
                        }
                    } else {
                        table += `<td>${element3}</td>`;
                    }
                });
                table += "</tr>";
            });
            table += "</table>";
            document.querySelector(`#outputFormContainer`).insertAdjacentHTML(
                'beforeend',
                `<h5>${element['title_' + this.modules.localization.getLocale().split('-')[0]]}</h5><div class="row mt-xl-10"><div class="col pt-1 pb-0">${table}</div></div></div>`
            );
        });
    }
}